<div mat-dialog-title>
  <span>{{ 'URL_LIBRARY.SYNC_URL_TITLE' | translate }}</span>
  <q9-dialog-close-button></q9-dialog-close-button>
</div>

<mat-dialog-content class="content">
  <q9-info-message class="modal-info-message">
    {{ 'URL_LIBRARY.SYNC_URL_DESCRIPTION' | translate }}
  </q9-info-message>
  <form [formGroup]="syncForm" #form="ngForm">
    <mat-radio-group class="radio-group" formControlName="radio">
      <mat-radio-button
        color="primary"
        class="radio-group__button"
        [checked]="true"
        value="diagram">
        {{ 'POPUPS.THEME_ONLY_DIAGRAM' | translate }}
      </mat-radio-button>
      <mat-radio-button color="primary" class="radio-group__button" value="children">
        {{ 'POPUPS.THEME_DIAGRAM_AND_LOWER' | translate }}
      </mat-radio-button>
    </mat-radio-group>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <q9-secondary-button mat-dialog-close>
    {{ 'POPUPS.CANCEL' | translate }}
  </q9-secondary-button>
  <q9-primary-button (click)="form.onSubmit($event); sync()">
    {{ 'POPUPS.SYNC_BTN' | translate }}
  </q9-primary-button>
</mat-dialog-actions>
